import { useEffect } from 'react';
import { toast } from 'sonner';
import { useSnackbar } from 'contexts/SnackbarContext';

const GlobalSnackbar = (): null => {
  const { currentMessage, hideSnackbar } = useSnackbar();

  useEffect(() => {
    if (!currentMessage) {
      return;
    }

    const { message, severity, autoHideDuration } = currentMessage;
    const options = {
      duration: autoHideDuration ?? 3000,
      onDismiss: hideSnackbar,
      onAutoClose: hideSnackbar,
    };

    switch (severity) {
      case 'success': {
        toast.success(message, options);
        break;
      }
      case 'error': {
        toast.error(message, options);
        break;
      }
      case 'warning': {
        toast.warning(message, options);
        break;
      }
      case 'info': {
        toast.info(message, options);
        break;
      }
      default: {
        toast(message, options);
        break;
      }
    }
  }, [currentMessage, hideSnackbar]);

  return null;
};

export default GlobalSnackbar;
